export const DASHBOARD_OVERVIEW_KEY = 'overview';

export const DASHBOARD_TOOL_ROUTE_MAP: Record<string, string> = {
  [DASHBOARD_OVERVIEW_KEY]: 'summary',
  // Test: "Konfiguration" opens the new configurator; the old one is 'configurator'.
  configuration: 'configurator-v2',
  tasks: 'tasks',
  changes: 'changes',
  orders: 'orders',
  corrections: 'corrections',
  team: 'team',
  contacts: 'contacts',
  calendar: 'calendar',
  email: 'mailings',
  logbook: 'logbook',
  siteDiary: 'site-diary'
};

export function getDashboardPathForTool(toolKey: string): string {
  return DASHBOARD_TOOL_ROUTE_MAP[toolKey] || DASHBOARD_TOOL_ROUTE_MAP[DASHBOARD_OVERVIEW_KEY];
}

export function getDashboardToolKeyFromUrl(url: string): string {
  const path = (url || '').split('?')[0].toLowerCase();

  if (path.endsWith('/summary')) return DASHBOARD_OVERVIEW_KEY;
  if (path.includes('/stage-tasks/')) return '';
  if (path.includes('/configurator')) return 'configuration';
  if (path.includes('/tasks')) return 'tasks';
  if (path.includes('/changes')) return 'changes';
  if (path.includes('/orders')) return 'orders';
  if (path.includes('/corrections')) return 'corrections';
  if (path.includes('/team')) return 'team';
  if (path.includes('/contacts')) return 'contacts';
  if (path.includes('/calendar')) return 'calendar';
  if (path.includes('/mailings')) return 'email';
  if (path.includes('/logbook')) return 'logbook';
  if (path.includes('/site-diary')) return 'siteDiary';

  return DASHBOARD_OVERVIEW_KEY;
}
